// when clicking on a select2 box, this will focus the cursor on the search box.
// https://stackoverflow.com/a/67691578
$(document).on('select2:open', (e) => {
  const selectId = e.target.id
  $(".select2-search__field[aria-controls='select2-" + selectId + "-results']").each(function (key,value){
      value.focus();
  })
})
